// extracted by mini-css-extract-plugin
export default {"label":"label_label__a5ojB","note":"label_note__cZ868"};